import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { prop } from 'ramda';
import { getCleanUrl } from 'js/utils/url.util';
import { languageService } from 'js/services/language.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import { useSetLanguagePathname } from './useSetLanguagePathname';

export const useNormalizeUrl = () => {
    const history = useHistory();
    const location = useLocation();
    const { pathLang } = useParams<{ pathLang: string }>();
    const userLang = useUserSelector(prop('lang'));
    const defaultLanguage = useAppSelector(prop('defaultLocale'));
    const setLanguagePathname = useSetLanguagePathname();
    const formattedPathLang = languageService.getLanguage(pathLang);

    useEffect(() => {
        if (!defaultLanguage || !userLang) {
            return;
        }

        if (userLang === defaultLanguage && formattedPathLang === defaultLanguage) {
            // can't use navigateWithReplace because it navigates without removing lang
            history.replace({
                ...location,
                pathname: getCleanUrl(location.pathname)
            });

            return;
        }

        if (!pathLang && userLang !== defaultLanguage || languageService.getPathLang(formattedPathLang) !== pathLang) {
            setLanguagePathname(formattedPathLang || userLang, true);
        }
    }, [defaultLanguage, pathLang, location, userLang, setLanguagePathname, history, formattedPathLang]);
};
